/** Frontmatter for the "reading-trade-value" article; the Body lives in reading-trade-value.jsx. */
const meta = {
  slug: 'reading-trade-value',
  title: 'How to Read Trade Value',
  category: 'Trades',
  excerpt: 'Winning trades are not about robbing your league-mates. They are about trading from surplus to fill a need, on both sides.',
  readMinutes: 5,
  date: '2026-07-24',
};

export default meta;
